import React, { useContext, useState } from 'react'
import styles from "./infoBox.module.css";
import { AuthContext } from '../../../../contextAPI';
import add_logo from "../../../../assets/add.png"
import remove_logo from "../../../../assets/remove.png"
import InsideBounce from '../../../bounce/InsideBounce';

import Modal from '../../../modal';
import TimePopUp from './timePopUp';
import { UpdateSchedule } from '../../../../utils/shedule';
import { notify } from '../../../toast';

const InfoBox = (props) => {

    const User = useContext(AuthContext)
    const token = User.isLoggedIn ? User.authenticatedUser.token.access_token : null

    
    const todaysTimeArray = props.TimeArray.filter(obj => obj.schedule_date === props.selectedDate)[0]
    const requirements = props.selectedDate && !(todaysTimeArray && todaysTimeArray.schedule_hours && todaysTimeArray.schedule_hours.length > 0) && !props.isLoading
    
    const lastTodaysTime = todaysTimeArray && todaysTimeArray.schedule_hours
    const UserRequirements = props.selectedDate && User.isLoggedIn

    const [showTimePopUp,setShowTimePopUp] = useState(false);

    const removeTimeHandler = async() => {

        try {

            const response = await UpdateSchedule({
              schedule_date: props.selectedDate,
              work_hours: props.selectedTime,
              project_id: process.env.REACT_APP_PROJECT_ID,
            },token)
      
      
            if(!response.status || !response.data)throw new Error(response.message)
      
            return onShowScheduleHandler(response.data)
      
          } catch (error) {
            notify(error.message || "Negalimas veiksmas", "error")
          }

        }

    const onShowScheduleHandler = (updatedArray) => {
        setShowTimePopUp(false);
        return props.onRefresh(updatedArray.schedule)
    }

    return (
        <div className={styles.info}>
            <Modal
                show={showTimePopUp}
                onClose={()=>{setShowTimePopUp(false)}}
            >
                <TimePopUp onShowSchedule={onShowScheduleHandler} lastTodaysTime={lastTodaysTime} {...props}/>
            </Modal>
            {   requirements && !User.isLoggedIn &&
                <h3>Pasirinktai dienai neturime laisvų vietų <span>🫢</span></h3>
            }
            {   
                UserRequirements && 
                <>
                    <img onClick={()=>{setShowTimePopUp(true)}} alt='pridėti' src={add_logo} />
                    {props.selectedTime && <img style={{ marginLeft:"10px" }} onClick={removeTimeHandler} alt='pašalinti' src={remove_logo} />}
                </>
            }
            
            {
                !props.selectedDate &&
                <h3>Pasirinkite dieną</h3>
            }

            {   props.isLoading &&
                <InsideBounce />
            }
        </div>
    )
}

export default InfoBox